import React, { useMemo } from "react"
import { OverflowList, Boundary, IOverflowListProps } from "@blueprintjs/core"
import { take } from "lodash-es"

// an empty interface for providing
export interface CustomOverflowListProps<T> extends IOverflowListProps<T> {}
const CustomOverflowList = ({
  items,
  className,
  overflowRenderer,
  visibleItemRenderer,
  collapseFrom,
  ...otherProps
}: CustomOverflowListProps<null>) => {
  const validItems = useMemo(() => take(items, 30), [items])
  return (
    <OverflowList
      className={className}
      items={validItems}
      overflowRenderer={overflowRenderer}
      visibleItemRenderer={visibleItemRenderer}
      collapseFrom={collapseFrom}
      {...otherProps}
    />
  )
}

CustomOverflowList.defaultProps = {
  collapseFrom: Boundary.END,
}

export default CustomOverflowList
